import React from 'react'
import PropTypes from 'prop-types'
import { useTranslate } from 'react-admin'
import { Card, CardHeader, makeStyles, Avatar } from '@material-ui/core'
import { useMutation } from 'react-query'
import DialogWithCloseIcon from '../../../components/DialogWithCloseIcon/DialogWithCloseIcon'
import postMetaAccessToken from '../../../Apis/social/postMetaAccessToken'

const useStyles = makeStyles({
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '15px',
    cursor: 'pointer',
    height: '60px',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  avatar: {
    width: '40px',
    height: '40px',
    marginRight: '10px',
  },
  cardHeader: {
    flex: '0 1 auto',
    padding: '10px',
  },
})

// Account picker for the Meta connect flow. orgId (passed in by the caller) is the org the
// account is linked to; competitionId (when set) scopes the link to a single competition
// (federation).
const MetaAccountChoice = ({ accounts, setMetaAccounts, orgId, competitionId, onConnected }) => {
  const classes = useStyles()
  const translate = useTranslate()

  const onCloseDialog = () => setMetaAccounts([])

  const postAccessTokenMutation = useMutation((data) => postMetaAccessToken(data), {
    onSuccess: () => {
      onConnected?.()
      onCloseDialog()
    },
  })

  const onAccountChose = (account) => {
    postAccessTokenMutation.mutate({ orgId, accessToken: account?.access_token, competitionId })
  }

  return (
    <DialogWithCloseIcon
      open={Boolean(accounts.length)}
      onClose={onCloseDialog}
      dialogTitle={translate('ra.text.chooseAccountToConnect')}
      dialogWidth='30%'
    >
      {accounts && accounts.length ? (
        accounts.map((account) => (
          <Card key={account.id} onClick={() => onAccountChose(account)} className={classes.card}>
            <CardHeader
              className={classes.cardHeader}
              avatar={<Avatar className={classes.avatar} src={account?.picture || ''} />}
              title={account.name}
              titleTypographyProps={{ variant: 'body1' }}
            />
          </Card>
        ))
      ) : (
        <div>{translate('ra.text.noAccounts')}</div>
      )}
    </DialogWithCloseIcon>
  )
}

MetaAccountChoice.propTypes = {
  accounts: PropTypes.array.isRequired,
  setMetaAccounts: PropTypes.func.isRequired,
  orgId: PropTypes.string,
  competitionId: PropTypes.string,
  onConnected: PropTypes.func,
}

MetaAccountChoice.defaultProps = {
  orgId: undefined,
  competitionId: null,
  onConnected: undefined,
}

export default MetaAccountChoice
